import {
    Box,
    Card,
    CardContent,
    CardHeader,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    Select,
    TextField,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Autocomplete from '@material-ui/lab/Autocomplete'
import React, { useEffect, useState } from 'react'

import { states } from '../../../services/helpers'
import { TIME_ZONE_ABBREVIATIONS } from '../../../utils'

const useStyles = makeStyles((theme) => ({
	row: {
		width: '100%',
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		'& .MuiTextField-root, .MuiAutocomplete-root, .MuiFilledInput-root': {
			// width: 270,
			minWidth: 270
		},
		'& .MuiSvgIcon-root': {
			color: '#3B0275',
			fill: '#3B0275'
		}
	},
	input: {
		marginBottom: theme.spacing(2),
		width: '32%'
		// marginRight: theme.spacing(2)
	}
}))

const BasicSettings = ({ selectedMarket, updateMarket }) => {
	const classes = useStyles()

	return (
		<Card>
			<CardHeader title="Basic Settings" />
			<CardContent>
				<Box className={classes.row}>
					<TextField
						className={classes.input}
						id="play-style"
						value={`${selectedMarket?.city}, ${selectedMarket?.state}`}
						disabled={true}
						variant="filled"
						label="Name"
						required
					/>

					<TextField
						className={classes.input}
						value={selectedMarket?.city}
						onChange={(e, v) => updateMarket('city', e.target.value)}
						variant="filled"
						label="City"
						required
						InputLabelProps={{ shrink: !!selectedMarket?.city }}
					/>

					<Autocomplete
						className={classes.input}
						size="small"
						getOptionLabel={(option) => option.name}
						id="household-select"
						required
						options={states || []}
						value={
							selectedMarket?.state
								? states.find((s) => s.abbreviation === selectedMarket?.state)
								: ''
						}
						onChange={(e, v) => updateMarket('state', v.abbreviation)}
						onClose={(e) => {
							e.target.value = ''
						}}
						renderOption={(option) => (
							<React.Fragment>
								<ListItemText primary={option.name} />
							</React.Fragment>
						)}
						renderInput={(params) => <TextField {...params} variant="filled" label="State" required />}
					/>

					<FormControl className={classes.input} required>
						<InputLabel>Timezone</InputLabel>
						<Select
							required
							variant="filled"
							value={selectedMarket?.time_zone || ''}
							onChange={(e) => {
								updateMarket('time_zone', e.target.value)
							}}>
							{Object.entries(TIME_ZONE_ABBREVIATIONS).map(([val, label]) => (
								<MenuItem key={val} value={val}>
									{label}
								</MenuItem>
							))}
						</Select>
					</FormControl>

					<TextField
						className={classes.input}
						value={selectedMarket?.phone_number}
						variant="filled"
						label="Phone Number"
						onChange={(e, v) => {
							e.preventDefault()
							updateMarket('phone_number', e.target.value)
						}}
						InputLabelProps={{ shrink: !!selectedMarket?.phone_number }}
					/>

					<TextField
						className={classes.input}
						value={selectedMarket?.latitude}
						variant="filled"
						type="number"
						label="Latitude"
						onChange={(e, v) => {
							e.preventDefault()
							updateMarket('latitude', e.target.value)
						}}
						required
						InputLabelProps={{ shrink: !!selectedMarket?.latitude }}
					/>

					<TextField
						className={classes.input}
						value={selectedMarket?.longitude}
						variant="filled"
						type="number"
						label="Longitude"
						onChange={(e, v) => {
							e.preventDefault()
							updateMarket('longitude', e.target.value)
						}}
						required
						InputLabelProps={{ shrink: !!selectedMarket?.longitude }}
					/>
				</Box>
			</CardContent>
		</Card>
	)
}

export default BasicSettings
